/**
 * Global wishlist heart toggle — handles every [data-wishlist-toggle]
 * button on the page, regardless of which section/snippet rendered it
 * (snippets/wishlist-button.liquid, used by card-product.liquid and
 * new-arrivals-carousel.liquid). Loaded unconditionally in
 * layout/theme.liquid so hearts work on every template.
 */
(function () {
  if (window.__wishlistButtonBound) return;
  window.__wishlistButtonBound = true;

  function syncWishlistButtons() {
    if (!window.Wishlist) return;
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = window.Wishlist.has(button.getAttribute('data-wishlist-id'));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove from Wish List' : 'Add to Wish List');

      var inlineLabel = button.querySelector('[data-wishlist-inline-label]');
      if (inlineLabel) inlineLabel.textContent = active ? 'Remove from Wishlist' : 'Add to Wishlist';
    });
  }

  var toastTimer = null;
  function showToast(message) {
    var toast = document.querySelector('[data-wishlist-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.setAttribute('data-wishlist-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  var tooltipEl = null;
  function showTooltip(button) {
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.className = 'wishlist-tooltip';
      document.body.appendChild(tooltipEl);
    }
    tooltipEl.textContent = button.getAttribute('aria-label');
    var rect = button.getBoundingClientRect();
    tooltipEl.style.left = rect.left + rect.width / 2 + 'px';
    tooltipEl.style.top = rect.bottom + 8 + 'px';
    tooltipEl.classList.add('is-visible');
  }
  function hideTooltip() {
    if (tooltipEl) tooltipEl.classList.remove('is-visible');
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      var button = event.target.closest('[data-wishlist-toggle]');
      if (button) showTooltip(button);
    },
    true
  );
  document.addEventListener(
    'mouseout',
    function (event) {
      var button = event.target.closest('[data-wishlist-toggle]');
      if (button) hideTooltip();
    },
    true
  );
  document.addEventListener('focusin', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (button) showTooltip(button);
  });
  document.addEventListener('focusout', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (button) hideTooltip();
  });

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-wishlist-toggle]');
      if (!button || !window.Wishlist) return;
      event.preventDefault();
      event.stopPropagation();

      var wasActive = window.Wishlist.has(button.getAttribute('data-wishlist-id'));
      window.Wishlist.toggle({
        id: button.getAttribute('data-wishlist-id'),
        variant: button.getAttribute('data-wishlist-variant'),
        title: button.getAttribute('data-wishlist-title'),
        url: button.getAttribute('data-wishlist-url'),
        image: button.getAttribute('data-wishlist-image'),
        price: button.getAttribute('data-wishlist-price')
      });
      showToast(wasActive ? 'Removed from Wish List' : 'Added to Wish List');
    },
    true
  );

  function updateWishlistCountBubble() {
    if (!window.Wishlist) return;
    var count = window.Wishlist.getAll().length;
    document.querySelectorAll('[data-wishlist-count-bubble]').forEach(function (bubble) {
      bubble.classList.toggle('is-visible', count > 0);
      var countEl = bubble.querySelector('[data-wishlist-count]');
      if (countEl) countEl.textContent = count < 100 ? count : '';
      var labelEl = bubble.querySelector('[data-wishlist-count-label]');
      if (labelEl) labelEl.textContent = count + (count === 1 ? ' item in Wish List' : ' items in Wish List');
    });
  }

  document.addEventListener('wishlist:change', syncWishlistButtons);
  document.addEventListener('wishlist:change', updateWishlistCountBubble);
  document.addEventListener('DOMContentLoaded', syncWishlistButtons);
  document.addEventListener('DOMContentLoaded', updateWishlistCountBubble);
  if (document.readyState !== 'loading') {
    syncWishlistButtons();
    updateWishlistCountBubble();
  }
})();
